<script setup lang="ts">
import { useRouter } from 'vue-router'
import { Menu } from '../../../types/auth';
import IconComponent from '../../ui/common/IconComponent.vue';
import Tooltip from '../../ui/common/Tooltip.vue';

const router = useRouter()

defineProps<{
  menu?: Menu[]
}>()

const handleItemClick = (path: string) => {
  path = path.substring(0,1) == '/' ? path : '/' + path
  router.push(path)
}
</script>

<template>
  <nav class="py-2 mt-3">
    <div v-for="m in menu" :key="m.uid" class="mb-4 last:mb-0">
      <h3 class="px-4 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
        {{ m.name }}
      </h3>
      <ul>
        <li v-for="item in m.sub_menus" :key="item.name">
          <Tooltip :text="item.intro">
            <a 
              href="#" 
              @click.prevent="handleItemClick(item.route_path || '#')"
              class="flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-blue-50 dark:hover:bg-blue-900/50 hover:text-blue-600 dark:hover:text-blue-400 group"
            >
              <IconComponent :name="item.icon_css" class="pr-1" />
              <!--<span class="mr-3 text-gray-400 group-hover:text-blue-500">{{ item.icon_css }}</span>-->
              {{ item.name }}
            </a>
          </Tooltip>
        </li>
      </ul>
    </div>
  </nav>
</template>